<template xmlns="http://www.w3.org/1999/html">
  <div class="bg-white rounded box-shadow p-3">
    <b-modal id="jvc-add-modal" size="lg" title="JVC Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <form action="" enctype="multipart/form-data" files="true" role="form">
          <div class="form-row">
            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="district_id">District <span
                  class="c-required">*</span> </label>
                  <!-- @change="getUniqueJvcNo(district_id)" -->
              <select v-model="district_id"  v-validate="{ required: true }" class="form-control form-control-sm"
                      name="district_id"
                      id="district_id">
                <option selected :value="''">Select a District</option>
                <option v-for="(district, index) in districts" :key="index" :value="district.id">{{ district.id }} :
                  {{ district.district_desc }}
                </option>
              </select>
            </div>

            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="is_titled">Select Titled/Non-Titled<span
                  class="c-required">*</span></label>
              <select v-model="is_titled" v-validate="{ required: true }" class="form-control form-control-sm"
                      name="is_titled"
                      id="is_titled">
                <option selected :value="''">Select Titled/Non-Titled</option>
                <option value="1">Titled</option>
                <option value="0">Non-Titled</option>
              </select>
            </div>

            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="jvc_no">JVC No <span
                  class="c-required">*</span></label>
              <select v-model="jvc_no" v-validate="'required'" class="form-control form-control-sm" name="jvc_no"
                      id="jvc_no">
                <option selected :value="''">Select a JVC No</option>
                <option v-for="(jvc_number, index) in jvc_numbers" :key="index" :value="jvc_number">
                  {{ jvc_number }}
                </option>
              </select>
              <div class="invalid-feedback">JVC No is required</div>
            </div>

          </div>
          <div class="form-row mt-2">
            
            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="jvc_date">Jvc Date <span class="c-required">*</span></label>
              <input type="date" v-model="jvc_date" v-validate="{ required: true }" id="jvc_date" name="jvc_date"
                     placeholder="Jvc Date.." class="form-control form-control-sm"/>
              <div class="invalid-feedback">Jvc Date is required</div>
            </div>

            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="number_eps">Number of EPs <span
                  class="c-required">*</span></label>
              <input type="number" v-model="number_eps" v-validate="{ required: true }" id="number_eps"
                     name="number_eps" placeholder="Number of EPs" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Number of Eps is required</div>
            </div>

            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="number_ep_files">Number of EP Files <span
                  class="c-required">*</span></label>
              <input type="number" v-model="number_ep_files" v-validate="{ required: true }" id="number_ep_files"
                     name="number_ep_files" placeholder="Number of EP Files" class="form-control form-control-sm"/>
              <div class="invalid-feedback">Number of EP Files</div>
            </div>


            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="is_grc">Select Is GRC <span
                  class="c-required">*</span></label>
              <select v-model="is_grc" v-validate="{ required: true }" class="form-control form-control-sm"
                      name="is_grc"
                      id="is_grc">
                <option selected :value="''">Select Is GRC</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>

          </div>

          <b-button class="form-control-sm mr-2 mt-3" size="sm" variant="success" @click.prevent="save">Save</b-button>
          <b-button class="form-control-sm mt-3" size="sm" variant="danger" @click="$bvModal.hide('jvc-add-modal')">
            Cancel
          </b-button>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  name: "addJvcModal",
  data() {
    return {
      districts: [],
      jvc_no: '',
      jvc_date: '',
      number_ep_files: '',
      number_eps: '',
      district_id: '',
      is_titled: '',
      is_grc: '',

      validation_errors: {},
      show: false
    };
  },

  mounted() {
    this.getCodes();
  },

  asyncComputed:{
   async jvc_numbers(){
      if(this.district_id && this.is_titled){
        let response = await this.getUniqueJvcNo(this.district_id, this.is_titled)
        return response.data.jvc_numbers
      } else
        return []
    }
  },

  methods: {
    async getUniqueJvcNo(district_id, is_titled) {
      return await http.get(`api/jvc/get-jvc-unique-no/${district_id}/${is_titled}`)
    },
    getCodes() {
      http.get("api/jvc/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.districts = data.districts;
        }
      });
    },
    getFile() {
      this.file = this.$refs.file.files[0];
      if (this.file.size > 10000000) {
        this.$bvToast.toast("File size not greater then 10 MB", {
          title: "Error",
          autoHideDelay: 5000,
          variant: "error"
        });
        this.file = "";
      }
    },

    save() {
      this.btn_edit = false;
      this.$validator.validate().then(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append("district_id", this.district_id);
          formData.append("jvc_no", this.jvc_no);
          formData.append("jvc_date", this.jvc_date);
          formData.append("number_eps", this.number_eps);
          formData.append("number_ep_files", this.number_ep_files);
          formData.append("is_titled", this.is_titled);
          formData.append("is_grc", this.is_grc);

          http.post("api/jvc/store", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Content-type": "application/json"
            }
          })
              .then(response => {
                if (!response.error) {
                  this.$bvToast.toast("JVC saved successfully", {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.resetForm();
                  this.$emit("search");
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
    resetForm() {
      this.$validator.reset();
      this.district_id = "";
      this.jvc_no = "";
      this.jvc_date = "";
      this.number_eps = "";
      this.number_ep_files = "";
    },
  },

};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.custom-select {
  -webkit-appearance: unset;
}

.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}

.multiselect__tags {
  border-color: #ced4da;
  border-radius: 3px;
  min-height: 31px;
  padding: 4px 25px 0px 10px;
  margin-bottom: 0;
}

.multiselect__tag {
  margin-bottom: 0px;
}

.multiselect__placeholder {
  margin-bottom: 0px;
}

.multiselect__select {
  height: 31px;
}

.custom-select {
  color: #6c757d !important;
}

.c-required {
  color: red;
}
</style>
